import React, { useState } from 'react';
import HeaderContext from './HeaderContext';

const defaultHeaderContext = {
  refreshTimeline: undefined,
  cartItemsCount: undefined
};
const HeaderContextProvider = (props) => {
  const [headerContext, setHeaderContext] = useState(defaultHeaderContext);
  const value = { headerContext, setHeaderContext };
  return <HeaderContext.Provider value={value} {...props} />;
};

export default HeaderContextProvider;
